<template>
  <div class="font-content">
    <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 如果当前打开页面的路由中 没有 或者为 keepAlive: false （关闭缓存时[默认就是false]） -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <div v-if="ismobile" class="mob-phone">
            <a class="mob-phone-pos" href="tel:010-56293048">
                <img src="./assets/images/mob-dianhua.png" alt="" />
                <span>电话咨询</span>
            </a>
    </div>-->
    <!-- <div v-else class="pc-from">
            <div class="pc-from-top">
                <span>请您留言</span>
                <img src="./assets/images/pc-zuixiaohua.png" alt="" v-if="isformShow"  />
                <img src="./assets/images/pc-zuidahua.png" style="margin-top: 14px;" alt="" v-else />
                <div @click="changeformshow"></div>
            </div>
            <div v-if="isformShow" class="pc-from-bom">
                <h2>博努力（北京）仿真技术有限公司</h2>
                <p>010-56293048/4006563626</p>
                <textarea placeholder="请在此输入您的留言内容，我们会尽快与您取得联系（必填）" v-model="desc" ></textarea>
                <div class="pc-from-input">
                    <div>
                        <img src="./assets/images/pc-xingming.png" style="width: 14px;" alt="" />
                    </div>
                    <input placeholder="姓名" v-model="name" />
                </div>
                <div class="pc-from-input">
                    <div>
                        <img src="./assets/images/pc-dianhua.png" alt="" />
                    </div>
                    <input placeholder="电话" v-model="phone" />
                </div>
                <div class="pc-from-submit" @click="submit">发送</div>
            </div>
    </div>-->
  </div>
</template>

<script>
import { ApiMessage } from "./services/article";
export default {
  name: "app",
  data() {
    return {
      ismobile: false,
      isformShow: true,
      desc: "",
      name: "",
      phone: "",
    };
  },
  watch: {
    $route() {
      document.title = this.$route.meta.title;
    },
  },
  mounted() {
    //console.log("版本号：v1.0.2");
    document.title = this.$route.meta.title;
    if (this._isMobile()) {
      this.ismobile = true;
      // this.$router.push({
      //     name: 'mhome'
      // })
    } else {
      this.ismobile = false;
      // this.$router.push({
      //     name: 'home'
      // })
    }
  },
  methods: {
    _isMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    changeformshow() {
      this.isformShow = !this.isformShow;
    },
    submit() {
      if (this.desc == "") {
        alert("请输入留言内容");
        return;
      }
      if (this.name == "") {
        alert("请输入姓名");
        return;
      }
      if (this.phone == "") {
        alert("请输入电话");
        return;
      }
      ApiMessage({
        name: this.name,
        mobile: this.phone,
        content: this.desc,
      })
        .then((res) => {
          alert("提交成功");
        })
        .catch((err) => {
          alert("提交失败");
        });
    },
  },
};
</script>

<style>
html {
  font-size: 16px;
}
.active-return-top {
  width: 70px;
  height: 76px;
  position: fixed;
  right: 40px;
  bottom: 240px;
  cursor: pointer;
}
.mob-phone {
  height: 1rem;
  width: 100%;
}
.mob-phone-pos {
  position: fixed;
  display: block;
  z-index: 9999;
  bottom: 0;
  left: 0;
  height: 1rem;
  width: 100%;
  background: #0055d3;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mob-phone-pos:active {
  background: #0055d3;
}
.mob-phone-pos span {
  font-size: 0.36rem;
  color: #fff;
}
.mob-phone-pos img {
  width: 0.4rem;
  height: 0.4rem;
  margin: 0.2rem;
}
.pc-from {
  position: fixed;
  width: 250px;
  z-index: 9999;
  bottom: 40px;
  right: 40px;
}
.pc-from-top {
  height: 38px;
  background: url(./assets/images/pc-beijingtiao.png) center no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  padding: 0 10px;
  overflow: hidden;
}
.pc-from-top span {
  height: 38px;
  line-height: 38px;
  float: left;
}
.pc-from-top img {
  float: right;
  margin-top: 18px;
}
.pc-from-bom {
  height: 340px;
  background: #e8e7e7;
}
.pc-from-bom h2 {
  font-size: 14px;
  padding-left: 10px;
  padding-top: 15px;
  color: #504d4d;
}
.pc-from-bom p {
  font-size: 14px;
  padding-left: 10px;
  color: #0256d3;
  margin-top: 8px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;
}
.pc-from-bom textarea {
  width: 230px;
  height: 80px;
  margin: 10px;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
}
.pc-from-input {
  width: 230px;
  height: 36px;
  background: #fff;
  margin: 10px;
  align-items: center;
  overflow: hidden;
}
.pc-from-input div {
  width: 36px;
  height: 36px;
  float: left;
}
.pc-from-input img {
  width: 10px;
  height: 16px;
  margin-left: 13px;
  margin-top: 10px;
}
.pc-from-input input {
  border: 0 none;
  height: 36px;
  width: 190px;
  font-size: 14px;
  float: left;
}
.pc-from-submit {
  font-size: 14px;
  color: #fff;
  width: 100px;
  height: 36px;
  margin: 14px auto;
  line-height: 36px;
  text-align: center;
  border-radius: 5px;
  background: #0256d3;
}
.pc-from-top div {
  position: absolute;
  right: 5px;
  height: 30px;
  width: 30px;
  top: 3px;
}
</style>
